import moment from "moment/moment";
import React from "react";
import { BackIcon } from "../../asset";
import UserManagement from "../user-management/UserManagement";
import usePageHeaders from "./pages-header.hooks";
import { convertDate } from "../../util/Util";

const HeaderPages = ({
  title,
  data,
  delivery,
  driver_name,
  vehicle_type,
  handleBack,
  company_profile,
  menuType,
  temperature,
  temperature_code,
  withName,
  name,
}) => {
  const { drawer, _openDrawer, _closeDrawer } = usePageHeaders();

  return (
    <>
      <div className=" flex flex-row justify-between">
        {menuType === "list" ? (
          <>
            <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
              {title}
            </p>
          </>
        ) : company_profile ? (
          <>
            <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
              {title}
            </p>
            <div
              className=" flex justify-center items-center"
              onClick={_openDrawer}
            >
              <p className="bg-gray-900 p-2 rounded-md cursor-pointer">
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {`Created By `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.created_by ? data?.created_by : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` On `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.created_at
                    ? moment().utc(data?.created_at).format("DD-MMM-YYYY")
                    : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` | Last Modified By `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.updated_by ? data?.updated_by : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` On `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.updated_at
                    ? moment().utc(data?.updated_at).format("DD-MMM-YYYY")
                    : "-"}{" "}
                </span>
              </p>
            </div>
          </>
        ) : menuType === "add" ? (
          <>
            <div
              className="flex items-center gap-[20px] cursor-pointer"
              onClick={handleBack}
            >
              <img src={BackIcon} alt="back-icons" />
              <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
                {title}
              </p>
            </div>
          </>
        ) : menuType === "edit" ? (
          <>
            <div
              className="flex items-center gap-[20px] cursor-pointer"
              onClick={handleBack}
            >
              <img src={BackIcon} alt="back-icons" />
              <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
                {withName ? title + " - " + name : title}
              </p>
            </div>
          </>
        ) : menuType === "edit-da" ? (
          <>
            <div
              className="flex items-center gap-[20px] cursor-pointer"
              onClick={handleBack}
            >
              <img src={BackIcon} alt="back-icons" />
              <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
                {`${title} ${driver_name} - ${vehicle_type}`}
              </p>
            </div>
          </>
        ) : (
          <>
            <div
              className="flex items-center gap-[20px] cursor-pointer"
              onClick={handleBack}
            >
              <img src={BackIcon} alt="back-icons" />
              <p className=" my-2 font-sans text-black-200 font-bold text-[28px]">
                {delivery
                  ? title + " " + driver_name + " - " + vehicle_type
                  : temperature
                  ? title + " - " + temperature_code
                  : title}
              </p>
            </div>
            <div
              className=" flex justify-center items-center"
              onClick={_openDrawer}
            >
              <p className="bg-gray-900 p-2 rounded-md cursor-pointer">
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {`Created By `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.created_by ? data?.created_by : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` On `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.created_at ? data?.created_at : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` | Last Modified By `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.updated_by ? data?.updated_by : "-"}{" "}
                </span>
                <span className="font-roboto text-gray-400 text-sm font-normal">
                  {" "}
                  {` On `}{" "}
                </span>
                <span className="font-roboto text-black-100 text-sm font-bold">
                  {" "}
                  {data?.updated_at
                    ? moment().utc(data?.updated_at).format("DD-MM-YYYY")
                    : "-"}{" "}
                </span>
              </p>
            </div>
          </>
        )}
      </div>
      <UserManagement drawer={drawer} closeDrawer={_closeDrawer} />
    </>
  );
};

export default HeaderPages;
